import { CameraType } from "APP_ROOT/data/media";
export default {
  name: "potential_speed_camera_violation",
  localization: {
    en: {
      title: "Potential speed camera violation",
      settingsHeader: "Potential Speed Camera Violation Detection",
    },
    fr: {
      title: "Violation potentielle de radar de vitesse",
      settingsHeader: "Détection de violation potentielle de radar de vitesse",
    }
  },
  proto: {
    name: "EVENT_RAVEN_POTENTIAL_SPEED_CAMERA_VIOLATION",
    value: 169
  },
  isBuiltByDefault: true,
  isBuiltEnvironmentOverride: {
    showcase: false,
    prod: false
  },
  visibility:{
    reports: true,
    coaching: true,
    coachingNoFacialRecognition: true,
    warning: true,
  },
  isConsumerFeature: false,
  defaultCameraType: CameraType.CAMERA_ROAD,
  showBetaDecoration: false,
}
